import { createSlice, createSelector } from "@reduxjs/toolkit";

const templateSliceSelector = createSlice({
  name: "templateSlice",
  initialState: {
    isLoading: false,
    loaderMessage : "",
    isLoadingNewAdd : false,
    templateList: [],
    userstemplateList :[]
  },
  reducers: {
    startGettingTemplateList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    startDeleteTemplateList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setTemplateList(state, action) {
      state.templateList = action.payload;
    },
    startGettingFilterTemplateList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setTemplateFilterList(state, action) {
      state.templateList = action.payload;
    },
    startTemplateListByUserId(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setUserTemplateList(state, action) {
      state.userstemplateList = action.payload;
    },
    startAddNewTemplate(state , action){
      state.isLoadingNewAdd = true;
      state.loaderMessage = "Adding Template please wait..."
    },
    completedFetch(state, action) {
      state.isLoading = false;
      state.loaderMessage = ""
    },
    completedNewAdd(state, action) {
      state.isLoadingNewAdd = false;
      state.loaderMessage = ""
    },
  },
});

export const {  startGettingTemplateList, startDeleteTemplateList, setTemplateList, startGettingFilterTemplateList, setTemplateFilterList, startTemplateListByUserId, setUserTemplateList, startAddNewTemplate, completedFetch, completedNewAdd} = templateSliceSelector.actions;
export default templateSliceSelector.reducer;

//Selector
const mainReducer = (state) => state.TemplateData;

export const templateListSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.templateList
);

export const userTemplateListSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.userstemplateList
);

export const isLoadingTemplateSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.isLoading
);
export const isLoadingForNewAddDataSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.isLoadingNewAdd
);
export const loaderMessageDataSelector = createSelector(
  [mainReducer],
  (myReducerStore)=> myReducerStore.loaderMessage
);